import config from "config";
import { APICore } from "helpers/api/apiCore";
import { BulkLimitConfigDownloadFileType, BulkLimitConfigFileCheckerRemarkType, BulkLimitConfigFileDetail, BulkLimitConfigFileMakerRemarkType, BulkLimitConfigFileVersionType, uploadBulkLimitConfigFileType } from "./types";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function uploadBulkLimitConfigFileApi(params: uploadBulkLimitConfigFileType) {
    let formData = new FormData();
    formData.append("file", params.bulkLimitConfigFile);
    let backendApiUrl = `${config.BACKEND_BASE_URL}/bulk-file/borrower_limit`;
    const baseUrl = backendApiUrl;
    return api.create(`${baseUrl}`, formData);
}

function fetchBulkLimitConfigFileApi(params: FilterMetadata) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/borrower_limit`;
    return api.get(`${baseUrl}`, params);
}

function downloadBulkLimitConfigFileApi(params: BulkLimitConfigDownloadFileType) {
    const baseUrl = `${config.BACKEND_BASE_URL}${params.downloadURL}`;
    return api.getFile(`${baseUrl}`, {});
}

function fetchBulkLimitConfigFileDetailApi(params: BulkLimitConfigFileDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/borrower_limit/${params.externalID}`;
    return api.get(`${baseUrl}`, {});
}

function fetchBulkLimitConfigFileVersionApi(params: BulkLimitConfigFileVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/versions`;
    return api.get(`${baseUrl}`, params.filter);
}

function bulkLimitConfigFilePublishApi(params: BulkLimitConfigFileMakerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/publish`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function approveBulkLimitConfigFileApi(params: BulkLimitConfigFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/approve`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function rejectBulkLimitConfigFileApi(params: BulkLimitConfigFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/reject`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function fetchBulkFileSpecificLimitConfigApi(params: BulkLimitConfigFileVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/borrower_limit/${params.externalId}/filerecords`;
    return api.get(`${baseUrl}`, params.filter);
}


function deleteBulkLimitConfigFileApi(params: BulkLimitConfigFileDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalID}`;
    return api.delete(`${baseUrl}`);
}

export {
    uploadBulkLimitConfigFileApi,
    fetchBulkLimitConfigFileApi,
    downloadBulkLimitConfigFileApi,
    fetchBulkLimitConfigFileDetailApi,
    fetchBulkLimitConfigFileVersionApi,
    bulkLimitConfigFilePublishApi,
    approveBulkLimitConfigFileApi,
    rejectBulkLimitConfigFileApi,
    fetchBulkFileSpecificLimitConfigApi,
    deleteBulkLimitConfigFileApi
}